export const gridPaymentItemProps = {
  item: true,
  xs: 12,
  sx: { display: 'flex', justifyContent: 'center' },
};

export const typographyWrap = {
  sx: {
    maxWidth: 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
